/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import {
	MaintenanceColorValues,
	VehicleStatus,
	VehicleStatusValues,
	moicPerNumberOfWeeks,
	moicSuggestedPerNumberOfWeeks,
} from 'models/inventory/enums/vehicle.enum';
import {
	Discount,
	SalePrices,
	VehiclePopulated,
} from 'models/inventory/interfaces/vehicle.interface';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/extensions
import SwiperClass from 'swiper/types/swiper-class';
// eslint-disable-next-line import/extensions
import Swipercore, { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// swiper bundle styles
import 'swiper/swiper-bundle.min.css';

// swiper core styles
import 'swiper/swiper.min.css';

// modules styles
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

// css
import './detailsI.scss';

// imgs
import { ReactComponent as Back } from 'design_system/src/static/icons/back.svg';
import { ReactComponent as Position } from 'design_system/src/static/icons/gps.svg';
import { ReactComponent as Moto } from 'design_system/src/static/icons/Motocycle.svg';
import { ReactComponent as UserCircle } from 'design_system/src/static/icons/user-circle.svg';
// import {ReactComponent as Add} from 'design_system/src/static/icons/add-bracket.svg';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-circle.svg';
import { ReactComponent as Edit } from 'design_system/src/static/icons/edit-text.svg';
import { ReactComponent as Image } from 'design_system/src/static/icons/image.svg';
import { ReactComponent as Refresh } from 'design_system/src/static/icons/refresh.svg';
import { ReactComponent as Warning } from 'design_system/src/static/icons/warning-circle.svg';

import {
	Button,
	DataTable,
	ModalConfirmation,
	Typography,
} from 'design_system/src';
import {
	editVehicle,
	getVehicleByInternalId,
	removeVehicleFile,
} from 'models/inventory/controllers/vehicle.controller';

// import { useDraggable } from 'libs/index';
import History from 'components/hocs/history/History';
import { LightTooltip } from 'components/hocs/tooltip/Tooltip';

import {
	informativeMessage,
	validationItem,
	validationItemState,
} from 'components/hocs/messages/messages';
import { RequireRole } from 'components/layouts/main/sidebar/Sidebar';
import { SecureS3Image } from 'components/SecureS3Image/SecureS3Image';
import { findAllFinancialFormsOzoner } from 'models/financial-form/controllers/financial-form.controller';
import { GenericFinancialForm } from 'models/financial-form/interfaces/financial-form.interfaces';
import {
	fetchCurrentDevice,
	removeDeviceVehicle,
	updateDevice,
} from 'models/geozon/controllers/device.controller';
import {
	fetchCurrentTile,
	removeTileVehicle,
	updateTile,
} from 'models/geozon/controllers/tile.controller';
import { Device } from 'models/geozon/interfaces/device.interface';
import { TileTracker } from 'models/geozon/interfaces/tile.interface';
import { findAllNotifications } from 'models/notification/controllers/notifications.controller';
import { Notify } from 'models/notification/interfaces/notifications.interface';
import { getOzonerByVehicle } from 'models/ozoner/controllers/ozoner.controller';
import { Ozoner } from 'models/ozoner/interfaces/ozoner.interface';
import { Roles } from 'models/ozonio/enums/ozonio.enum';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { momentLocal } from 'models/shared/helpers/dates';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { priceFormatFinancial } from 'models/shared/helpers/prices';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { getGenericMotoImageUrl } from 'models/upload/publicStorage';
import { openS3File } from 'models/upload/upload.controller';
import { toast } from 'react-toastify';
import AddEditDiscount from '../addEditDiscount/AddEditDiscount';
import AddVehicleFile from '../edit/AddVehicleFile';
import { typeOfDocumentOptions } from '../edit/constants';
import EditVehicle from '../edit/EditVehicle';
import EdiVehiclePricing from '../edit/EditVehiclePricing';
import { detailsData } from './constants';
import SelectDeviceModal from './SelectDeviceModal';

function DetailsInventory() {
	const [swiperRef, setSwiperRef] = useState<SwiperClass>();
	Swipercore.use([Navigation, Pagination, Autoplay]);
	const navigate = useNavigate();
	const { internalid } = useParams();
	const [vehicle, setVehicle] = useState<VehiclePopulated | null>();
	const [ozoner, setOzoner] = useState<Ozoner | undefined>();
	const [financialForms, setFinancialForms] = useState<GenericFinancialForm[]>(
		[],
	);
	const [loading, setloading] = useState<boolean>(false);
	const [slider, setSlider] = useState({ current: 0 });
	const [openDetails, setOpenDetails] = useState<boolean>(false);
	const [openEditPricing, setOpenEditPricing] = useState<boolean>(false);
	const [openAddEditDiscount, setOpenAddEditDiscount] =
		useState<boolean>(false);
	const [activeDiscount, setActiveDiscount] = useState<Discount | null>();

	const [loanTimes, setLoanTimes] = useState<SalePrices[]>();
	const [openHistory, setOpenHistory] = useState<boolean>(false);

	const [alarms, setAlarms] = useState<Notify[]>([]);

	const [hasKM, setHasKM] = useState(false);
	const [hasDays, setHasDays] = useState(false);
	const [hasPrice, setHasPrice] = useState(false);
	const [hasHardwareCost, setHasHardwareCost] = useState(false);
	const [hasSoftwareCost, setHasSoftwareCost] = useState(false);
	const [hasPurchaseCost, setHasPurchaseCost] = useState(false);
	const [hasExtraCost, setHasExtraCost] = useState(false);
	const [hasValidMoic, setHasValidMoic] = useState(false);

	const [photos, setPhotos] = useState<Record<string, any>[]>(() => []);
	const slideTo = (index: number) => {
		if (swiperRef) swiperRef.slideTo(index, 0);
	};

	const [device, setDevice] = useState<Device | null>();
	const [openDevices, setOpenDevices] = useState<boolean>(false);
	const [selectedDevice, setSelectedDevice] = useState<Device>();
	const [openDeviceConfirm, setOpenDeviceConfirm] = useState(false);
	const [openDeviceRemove, setOpenDeviceRemove] = useState(false);
	const [loadingSetDevice, setLoadingSetDevice] = useState(false);

	const [tile, setTile] = useState<TileTracker | null>();
	const [openTiles, setOpenTiles] = useState<boolean>(false);
	const [selectedTile, setSelectedTile] = useState<TileTracker>();
	const [openTileConfirm, setOpenTileConfirm] = useState(false);
	const [openTileRemove, setOpenTileRemove] = useState(false);
	const [loadingSetTile, setLoadingSetTile] = useState(false);
	const [openAddVehicleFile, setOpenAddVehicleFile] = useState(false);

	useEffect(() => {
		if (internalid) {
			findAllNotifications({ page: 1, vehicleInternalId: internalid }).then(
				(info) => {
					setAlarms(info.data);
				},
			);
			fetchCurrentDevice(internalid).then((dev) => {
				if (dev?.device) {
					setDevice(dev.device);
				}
			});
			fetchCurrentTile(internalid).then((dev) => {
				if (dev?.device) {
					setTile(dev.device);
				}
			});
		}
	}, [internalid]);

	const assignDevice = () => {
		if (vehicle && internalid && selectedDevice) {
			setLoadingSetDevice(true);
			updateDevice({ vehicle: vehicle._id }, selectedDevice._id)
				.then(() => {
					navigate(`/inventory/${internalid}`);
					return fetchCurrentDevice(internalid);
				})
				.then((dev: any) => {
					setLoadingSetDevice(false);
					setOpenDeviceConfirm(false);
					if (dev?.device) {
						setDevice(dev.device);
					}
				})
				.catch((e) => {
					setLoadingSetDevice(false);
					commonErrorHandler(e);
				});
		}
	};
	const removeDevice = () => {
		if (vehicle && internalid && device) {
			setLoadingSetDevice(true);
			removeDeviceVehicle(device._id)
				.then(() => {
					navigate(`/inventory/${internalid}`);
					return fetchCurrentDevice(internalid);
				})
				.then((dev: any) => {
					setLoadingSetDevice(false);
					setOpenDeviceRemove(false);
					setDevice(dev.device);
				})
				.catch((e) => {
					setLoadingSetDevice(false);
					commonErrorHandler(e);
				});
		}
	};
	const assignTile = () => {
		if (vehicle && internalid && selectedTile) {
			setLoadingSetTile(true);
			updateTile({ vehicle: vehicle._id }, selectedTile._id)
				.then(() => {
					navigate(`/inventory/${internalid}`);
					return fetchCurrentTile(internalid);
				})
				.then((dev: any) => {
					setLoadingSetTile(false);
					setOpenTileConfirm(false);
					if (dev?.device) {
						setTile(dev.device);
					}
				})
				.catch((e) => {
					setLoadingSetDevice(false);
					commonErrorHandler(e);
				});
		}
	};
	const removeTile = () => {
		if (vehicle && internalid && tile) {
			setLoadingSetTile(true);
			removeTileVehicle(tile._id)
				.then(() => {
					navigate(`/inventory/${internalid}`);
					return fetchCurrentTile(internalid);
				})
				.then((dev: any) => {
					setLoadingSetTile(false);
					setOpenTileRemove(false);
					setTile(dev.device);
				})
				.catch((e) => {
					setLoadingSetTile(false);
					commonErrorHandler(e);
				});
		}
	};

	const fetchVehicle = () => {
		getVehicleByInternalId(internalid)
			.then((vehi) => {
				setloading(false);
				setVehicle(vehi);
				if (vehi.images.length > 0) {
					setPhotos(vehi.images);
				}
			})
			.catch(() => {
				setloading(false);
				Swal.fire({
					title: 'Error!',
					text: 'Internal id no valido',
					icon: 'error',
					confirmButtonText: 'Aceptar',
				}).then(() => {
					navigate('/inventory');
				});
			});
	};

	useEffect(() => {
		setPhotos([
			{
				url: getGenericMotoImageUrl(),
			},
		]);
		setloading(true);
		fetchVehicle();
	}, []);

	useEffect(() => {
		if (vehicle) {
			getOzonerByVehicle(vehicle._id)
				.then((res) => {
					setOzoner(res);
					if (res) return findAllFinancialFormsOzoner(res._id);
					return [] as any;
				})
				.then((forms) => {
					setFinancialForms(forms);
				});

			if (vehicle.activeDiscount) setActiveDiscount(vehicle.activeDiscount);

			setLoanTimes(Object.values(vehicle.salePrices));

			setHasKM(vehicle.isNewVehicle || !!vehicle.mileage);
			setHasDays(
				!(
					vehicle.maintenanceDays === undefined ||
					vehicle.maintenanceDays === null ||
					(vehicle.maintenanceDays === 0 && !vehicle.isNewVehicle)
				),
			);
			setHasPrice(
				!!Object.values(vehicle.salePrices ?? {})?.length &&
					Object.values(vehicle.salePrices).reduce(
						(acc: boolean, price) => acc && price.paymentWeek > 50,
						true,
					),
			);
			setHasHardwareCost(vehicle.extraCosts?.gpsHardwareCost >= 0);
			setHasSoftwareCost(vehicle.extraCosts?.gpsMonthlySoftwareCost >= 0);
			setHasPurchaseCost(
				!(!vehicle.purchaseCost || vehicle.purchaseCost === 0),
			);
			setHasExtraCost(
				vehicle.isNewVehicle ||
					!(
						!vehicle.extraCosts?.basicExtraCost ||
						vehicle.extraCosts?.basicExtraCost === 0
					),
			);

			setHasValidMoic(
				!!Object.values(vehicle.salePrices ?? {})?.length &&
					Object.values(vehicle.salePrices).reduce(
						(acc: boolean, price) =>
							acc &&
							!!price.moic &&
							price.moic >= moicPerNumberOfWeeks[price.weeks],
						true,
					),
			);
		}
	}, [vehicle]);

	const setState = (status: VehicleStatus) => {
		setloading(true);
		if (vehicle) {
			editVehicle({ status }, vehicle.internalId)
				.then((vehi) => {
					setVehicle(vehi);
					if (vehi.images.length > 0) {
						setPhotos(vehi.images);
					}
				})
				.catch(() => {
					Swal.fire({
						text: 'No se pudo actualizar el vehículo',
						icon: 'error',
						confirmButtonText: 'Aceptar',
					});
				})
				.finally(() => setloading(false));
		}
	};

	const deleteFiles = (id: string) => {
		if (vehicle && internalid) {
			const toastId = toasterNotification({
				toasterType: toasterOptions.warning,
				msg: 'Eliminando archivo',
				style: 'light',
			});
			removeVehicleFile(internalid, id).then(() => {
				fetchVehicle();
				toast.dismiss(toastId);
				toasterNotification({
					toasterType: toasterOptions.success,
					msg: 'Archivo eliminado',
					style: 'light',
				});
			});
		}
	};

	const getDetails = (group: number) => {
		const data = [];
		if (group === 1) {
			data.push({ label: 'Marca', value: vehicle?.brand?.name });
			data.push({ label: 'Modelo', value: vehicle?.model?.name });
			data.push({
				label: 'Cilindraje',
				value: vehicle?.cylindersCapacity,
			});
			data.push({
				label: 'Kilometraje',
				value: vehicle?.mileage ?? 'Por confirmar',
			});
		}
		if (group === 0) {
			data.push({
				label: 'Precio GPS',
				value: priceFormatFinancial(vehicle?.extraCosts?.gpsHardwareCost ?? 0),
			});
			data.push({
				label: 'Precio Tile',
				value: priceFormatFinancial(vehicle?.extraCosts?.tileHardwareCost ?? 0),
			});
			data.push({
				label: 'Precio software GPS (Mensual)',
				value: priceFormatFinancial(
					vehicle?.extraCosts?.gpsMonthlySoftwareCost ?? 0,
				),
			});
		}
		return [
			...data,
			...detailsData[group].map((field) => ({
				label: field.title,
				value: `${
					field.map
						? field.map[vehicle?.[field.name] as string]
						: vehicle?.[field.name] ?? ''
				}`,
			})),
		];
	};

	const goToOzoner = () => {
		if (ozoner && vehicle && financialForms) {
			const findForm = financialForms.find(
				(form) => form.vehicle?.internalId === vehicle.internalId,
			);
			navigate(
				`/ozoner/${ozoner._id}${findForm ? `?formId=${findForm._id}` : ''}`,
			);
		} else {
			toasterNotification({
				toasterType: toasterOptions.error,
				msg: 'No fue posible redirigir al ozoner',
				style: 'light',
			});
		}
	};

	return (
		<div className=" display_flex detailsView overflow_hidden">
			{!loading && vehicle ? (
				<>
					<div className="flex_basis_0 flex_grow_1 overflow_x_hidden">
						<div className="">
							<div className="">
								<Button
									variant="icon"
									icon={<Back />}
									subvariant="edit"
									scale="small"
									onClick={() => navigate(-1)}
									className="m_b_lg"
								/>
								<div
									className="display_flex flex_col br_l_md"
									style={{ border: '1px solid #ECEEEF' }}
								>
									<div className="display_flex flex_gap_md flex_align_center p_xs">
										<LightTooltip
											title={
												vehicle.maintenanceDays
													? `Mantenimiento de ${vehicle.maintenanceDays} dias`
													: 'No dispone de informacion'
											}
										>
											<Moto
												className={`dim_lg text_${
													MaintenanceColorValues[vehicle.maintenanceColor]
														?.color ?? 'primary_300'
												}`}
											/>
										</LightTooltip>
										<Typography
											scale="heading2"
											weight="600"
											textColor="neutral_900"
										>
											{vehicle.internalId}
										</Typography>
										{vehicle.providerSku && (
											<Typography
												scale="small"
												weight="400"
												textColor="neutral_600"
											>
												SKU: {vehicle.providerSku}
											</Typography>
										)}
										<div>
											<div className="display_flex flex_gap_xs flex_align_center">
												<Typography
													scale="large"
													weight="600"
													textColor="primary_300"
													component="span"
												>
													{`${vehicle.brand.name} ${vehicle.model.name} ${
														vehicle.suffix ? vehicle.suffix : ''
													} ${vehicle.cylindersCapacity ?? ''}`}
												</Typography>
											</div>
											<div className="display_flex flex_gap_xs flex_align_center">
												<Position className="dim_lg text_neutral_900" />
												<Typography
													scale="large"
													weight="400"
													textColor="neutral_900"
													component="span"
												>
													{`${vehicle.location.city?.name} / ${vehicle.location.hub?.name}`}
												</Typography>
											</div>
										</div>
									</div>
									<div
										className="p_xs bg_neutral_300 display_flex flex_align_center flex_gap_xs"
										style={{
											borderTop: '1px solid #ECEEEF',
											borderBottomLeftRadius: '1rem',
										}}
									>
										<UserCircle className="text_primary_300" />
										<Typography
											scale="medium"
											weight="400"
											className="text_neutral_700"
										>
											{ozoner
												? `${ozoner.firstName ?? ''} ${
														ozoner.middleName ?? ''
												  } ${ozoner.lastName ?? ''} ${
														ozoner.secondLastName ?? ''
												  }`
												: 'Sin usuario'}
										</Typography>
										{ozoner && (
											<Button scale="small" variant="tint" onClick={goToOzoner}>
												Ver ozoner
											</Button>
										)}
									</div>
								</div>
							</div>
							<div className=" p_r_md">
								<Typography scale="large" weight="600" textColor="neutral_900">
									Descripción del vehículo
								</Typography>
								<hr className="m_y_md bg_neutral_500" />
								<Typography
									scale="medium"
									weight="400"
									textColor="neutral_700"
									className="m_b_md"
								>
									{vehicle.shortDescription}
								</Typography>
								<div className="dso_card bg_neutral_0 br_xs p_md m_b_xxl">
									<Swiper
										navigation
										onSwiper={setSwiperRef}
										className=" w_100_per m_b_md"
										onSlideChange={() => {
											setSlider({
												current: swiperRef ? swiperRef.activeIndex : 0,
											});
										}}
									>
										{photos.map((value, index) => (
											<SwiperSlide
												key={`slide-${index}`}
												className="overflow_hidden br_md flex_center"
											>
												<SecureS3Image
													src={value.url}
													path={value.path}
													alt="moto"
													className="swiper_img"
												/>
											</SwiperSlide>
										))}
									</Swiper>
									<div className="image-section">
										{[0, 1, 2, 3].map((_, index) => (
											<div
												className={`image-cont ${
													photos[index] ? 'dso_card' : 'empty'
												}  ${slider.current === index ? 'active' : ''}`}
												onClick={() => slideTo(index)}
												role="button"
												onKeyPress={() => slideTo(index)}
												tabIndex={0}
												key={`photo${index}`}
											>
												<div className="image-basis">
													{photos[index] && (
														<>
															<SecureS3Image
																src={photos[index].url}
																path={photos[index].path}
																alt="moto"
																className="center"
															/>
															{index === 3 && photos.length > 4 && (
																<div className="cover_img flex_center">
																	<Typography
																		scale="heading1"
																		weight="600"
																		textColor="primary_300"
																		className="text_center"
																	>
																		+{photos.length - 3}
																	</Typography>
																</div>
															)}
														</>
													)}
												</div>
											</div>
										))}
									</div>
								</div>
								<div className="display_flex flex_gap_md m_b_md">
									<RequireRole
										authRoles={[Roles.ADMIN, Roles.INVENTORY_MANAGER]}
									>
										<Button
											variant="outline"
											scale="small"
											icon={<Edit />}
											className="flex_basis_0 flex_grow_1"
											onClick={() => setOpenDetails(true)}
										>
											Editar
										</Button>
									</RequireRole>
								</div>
								<Button
									scale="small"
									variant="tint"
									icon={<Refresh />}
									onClick={() => setOpenHistory(true)}
									className="w_100_per  m_b_xxl"
								>
									Historial de cambios
								</Button>
								<Typography scale="large" weight="600" textColor="neutral_900">
									Especificaciones del vehículo
								</Typography>
								<hr className="m_y_md bg_neutral_500" />
								<DataTable
									data={getDetails(0)}
									weightLabels={2}
									className="m_b_xl"
								/>
								<DataTable
									data={getDetails(1)}
									weightLabels={2}
									className="m_b_xl"
								/>
								<Typography scale="large" weight="600" textColor="neutral_900">
									Detalles
								</Typography>
								<hr className="m_y_md bg_neutral_500" />
								<div className="border_solid border_neutral_300 border_1 p_lg m_b_xl">
									<Typography
										scale="medium"
										weight="400"
										textColor="neutral_700"
									>
										{vehicle.description}
									</Typography>
								</div>
							</div>
						</div>
					</div>
					<div className="flex_basis_0 flex_grow_1 overflow_x_hidden bg_neutral_300 display_flex flex_col">
						<div className="p_xl static_info_vehicle">
							<Typography
								scale="large"
								weight="600"
								textColor="neutral_900"
								className="m_b_md"
							>
								Información general
							</Typography>
							<div className="display_flex flex_gap_md m_b_md">
								<div className="flex_1 bg_neutral_0 br_md p_x_md p_y_xs">
									<div className="display_flex flex_justify_between flex_align_center m_b_xs">
										<Typography
											scale="large"
											weight="600"
											textColor="neutral_900"
											className=""
										>
											GPS
										</Typography>
										<RequireRole
											authRoles={[
												Roles.ADMIN,
												Roles.DEVICES_MANAGER,
												Roles.GPS_MANAGER,
											]}
										>
											<div className="display_flex flex_gap_md">
												<Edit
													className="text_primary_300 dim_lg cursor_pointer"
													onClick={() => setOpenDevices(true)}
												/>
												{device ? (
													<Close
														className="text_red_300 dim_lg cursor_pointer"
														onClick={() => setOpenDeviceRemove(true)}
													/>
												) : null}
											</div>
										</RequireRole>
									</div>
									<Typography
										scale="small"
										weight="400"
										textColor="neutral_900"
										className=""
									>
										{device ? device.imei : 'Sin Asignar'}
									</Typography>
								</div>
								<div className="flex_1 bg_neutral_0 br_md p_x_md p_y_xs">
									<div className="display_flex flex_justify_between flex_align_center m_b_xs">
										<Typography
											scale="large"
											weight="600"
											textColor="neutral_900"
											className=""
										>
											Tile
										</Typography>
										<RequireRole
											authRoles={[
												Roles.ADMIN,
												Roles.DEVICES_MANAGER,
												Roles.GPS_MANAGER,
											]}
										>
											<div className="display_flex flex_gap_md">
												<Edit
													className="text_primary_300 dim_lg cursor_pointer"
													onClick={() => setOpenTiles(true)}
												/>
												{tile ? (
													<Close
														className="text_red_300 dim_lg cursor_pointer"
														onClick={() => setOpenTileRemove(true)}
													/>
												) : null}
											</div>
										</RequireRole>
									</div>
									<Typography
										scale="small"
										weight="400"
										textColor="neutral_900"
										className=""
									>
										{tile ? tile.uuid : 'Sin Asignar'}
									</Typography>
								</div>
							</div>
							<div className="bg_neutral_400 br_sm  m_b_xxl">
								<div className="bg_neutral_0 br_t_sm display_flex p_y_sm p_x_lg flex_align_center flex_justify_between">
									<Typography
										scale="large"
										weight="600"
										textColor="neutral_900"
									>
										Estado del Vehículo
									</Typography>
									<div className="flex_center flex_gap_xs">
										<div
											className={`
                                            dso_chip_large
                                            pos_relative
                                            text_neutral_0
                                            bg_${
																							VehicleStatusValues[
																								vehicle.status as keyof typeof VehicleStatusValues
																							]?.color
																						}_nocontrast`}
										>
											{VehicleStatusValues[
												vehicle.status as keyof typeof VehicleStatusValues
											]?.title ?? vehicle.status}
										</div>
									</div>
								</div>
								<div className="p_x_lg p_t_xxxl p_b_xl display_flex flex_gap_sm flex_align_center">
									<div
										className="display_flex flex_gap_xs overflow_x_auto p_b_md"
										// ref={ref}
										// {...events}
									>
										<button
											type="button"
											className="dso_card bg_neutral_0 p_md w_fit border_primary_200 border_dotted display_flex flex_col flex_justify_between pos_relative"
											onClick={() => setOpenAddVehicleFile(true)}
										>
											<Typography
												scale="xsmall"
												weight="600"
												className="text_center m_b_md pdf_name"
												textColor="primary_300"
											>
												Añadir Documento
											</Typography>
											<div className="dso_card_img m_b_md bg_neutral_200 w_fit center_x display_flex overflow_hidden border_primary_300">
												<Image className="dim_xl m_lg text_primary_300 border_transparent" />
											</div>
										</button>
										{vehicle.documents &&
											vehicle.documents.map((ele: any, i: number) => (
												<div
													key={`photo${i}`}
													className="dso_card bg_neutral_0 p_md w_fit pos_relative display_flex flex_col flex_justify_between"
												>
													<Close
														className="text_red_300 dim_lg delete_photo"
														onClick={() => {
															deleteFiles(ele._id);
														}}
													/>
													<Typography
														scale="xsmall"
														weight="600"
														textColor="neutral_900"
														className="text_center m_t_md pdf_name"
													>
														{typeOfDocumentOptions
															.filter((type) => type.value === ele.typeEvidence)
															.map((type) => type.label)[0] ?? 'Desconocido'}
													</Typography>
													<button
														className="dso_card_img m_b_md bg_neutral_200 w_fit center_x display_flex overflow_hidden cursor_pointer"
														onClick={() =>
															openS3File({
																url: ele.url,
																path: ele.path,
															})
														}
														type="button"
														aria-label="Abrir documento"
													>
														<Image className="dim_xl m_lg" />
													</button>
												</div>
											))}
									</div>
								</div>
							</div>
							{vehicle.status === VehicleStatus.DRAFT && (
								<div className="display_flex flex_col flex_gap_md m_b_xxl">
									{internalid &&
										/[a-zA-Z]/.test(internalid[internalid.length - 1]) &&
										new Date().getFullYear() -
											(vehicle?.year ?? new Date().getFullYear()) >
											2 &&
										informativeMessage(
											'Considerada moto quedada',
											'Las motos recuperadas y que tienen mas de 2 años deberian pasar a quedadas',
											'neutral_800',
											'yellow_100',
										)}
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasKM
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]: 'Kilometraje asignado',
												[validationItemState.invalid]:
													'Kilometraje sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasPrice
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]: 'Precio asignado',
												[validationItemState.invalid]: 'Precio sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasDays
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]:
													'Dias de mantenimiento asignado',
												[validationItemState.invalid]:
													'Dias de mantenimiento sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasHardwareCost
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]:
													'Precio Hardware GPS asignado',
												[validationItemState.invalid]:
													'Precio Hardware GPS sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasSoftwareCost
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]:
													'Precio Software GPS asignado',
												[validationItemState.invalid]:
													'Precio Software GPS sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasPurchaseCost
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]: 'Precio Compra asignado',
												[validationItemState.invalid]:
													'Precio Compra sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasExtraCost
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]: 'Gastos extras asignado',
												[validationItemState.invalid]:
													'Gastos extras sin asignar',
											},
										)}
									</div>
									<div className="display_flex flex_gap_xs flex_align_center">
										{validationItem(
											hasValidMoic
												? validationItemState.valid
												: validationItemState.invalid,
											{
												[validationItemState.valid]: 'MOIC valido',
												[validationItemState.invalid]: 'MOIC Invalido',
											},
										)}
									</div>

									<Button
										scale="small"
										disabled={
											!hasKM ||
											!hasDays ||
											!hasPrice ||
											!hasHardwareCost ||
											!hasSoftwareCost ||
											!hasPurchaseCost ||
											!hasValidMoic ||
											!hasExtraCost
										}
										onClick={() => setState(VehicleStatus.AVAILABLE)}
									>
										Pasar moto a disponible
									</Button>
								</div>
							)}
							{vehicle.status === VehicleStatus.AVAILABLE && (
								<div className="display_flex flex_col flex_gap_md m_b_xxl">
									<Button
										scale="small"
										color="grey"
										onClick={() => setState(VehicleStatus.DRAFT)}
									>
										Devolver a Draft
									</Button>
								</div>
							)}
							<Typography
								scale="large"
								weight="600"
								textColor="neutral_900"
								className="m_b_lg"
							>
								Plan de pagos disponibles
							</Typography>
							<RequireRole
								authRoles={[Roles.ADMIN, Roles.INVENTORY_PRICE_MANAGER]}
							>
								<div className="display_flex flex_gap_md m_b_md">
									<Button
										variant="outline"
										scale="small"
										icon={<Edit />}
										className="flex_basis_0 flex_grow_1"
										onClick={() => setOpenEditPricing(true)}
										disabled={vehicle.status === VehicleStatus.DELIVERED}
									>
										Editar Precios
									</Button>
									<Button
										variant="outline"
										scale="small"
										icon={<Edit />}
										className="flex_basis_0 flex_grow_1"
										onClick={() => setOpenAddEditDiscount(true)}
									>
										Generar Descuento
									</Button>
								</div>
							</RequireRole>
							<div className="display_flex flex_gap_lg flex_justify_center m_b_lg">
								{loanTimes?.map((price: any) => (
									<div
										className="dso_card bg_neutral_0 br_sm"
										key={`price-${price.weeks}`}
									>
										<div className="bg_primary_300 p_lg br_t_sm">
											<Typography
												scale="medium"
												weight="600"
												textColor="neutral_0"
												className="text_center"
											>
												{price.weeks} semanas
											</Typography>
										</div>
										<div className="p_xs p_t_sm">
											<Typography
												scale="small"
												weight="600"
												textColor="neutral_900"
												className="text_center m_b_xxs"
											>
												Pago semanal
											</Typography>
											{price?.paymentWeekBeforeDiscount && (
												<Typography
													scale="large"
													weight="600"
													className="text_center text_red_300 text_decoration_line-through"
												>
													{priceFormatFinancial(
														price?.paymentWeekBeforeDiscount,
														0,
													)}
												</Typography>
											)}
											<Typography
												scale="heading3"
												weight="600"
												textColor="green_300"
												className="text_center m_b_xxs"
											>
												{priceFormatFinancial(price.paymentWeek, 0)}
											</Typography>
											<Typography
												scale="small"
												weight="600"
												textColor="neutral_900"
												className="text_center m_b_xxs"
											>
												Tasa de interés
											</Typography>
											<Typography
												scale="medium"
												weight="600"
												textColor="neutral_900"
												className="text_center m_b_xs"
											>
												{price.percentageIncrease}%
											</Typography>
											<div className="flex_center flex_gap_xs m_b_md">
												<div
													className={`br_md p_y_xxs p_x_xs bg_${
														price?.moic >=
														moicSuggestedPerNumberOfWeeks[price.weeks]
															? 'green_300'
															: price?.moic >= moicPerNumberOfWeeks[price.weeks]
															? 'yellow_100'
															: 'red_300'
													}`}
												>
													<Typography
														scale="xxsmall"
														weight="600"
														textColor="neutral_0"
														className="text_center"
													>
														MOIC{' '}
														{price?.moic
															? Math.floor(price.moic * 100) / 100
															: '--'}
														X
													</Typography>
												</div>
												<LightTooltip title="MOIC = Múltiplo del capital invertido Indica cuántas veces el cliente terminará pagando el monto originalmente financiado.">
													<div className="">
														<Warning className="dim_sm text_neutral_1000" />
													</div>
												</LightTooltip>
											</div>
											<div className="bg_neutral_300 br_b_sm p_x_lg p_y_sm">
												<Typography
													scale="small"
													weight="600"
													textColor="neutral_1000"
													className="text_center"
												>
													Precio de venta
												</Typography>
												{price?.loanAmountBeforeDiscount && (
													<Typography
														scale="small"
														weight="600"
														className="text_center text_red_300 text_decoration_line-through"
													>
														{priceFormatFinancial(
															price?.loanAmountBeforeDiscount,
															0,
														)}
													</Typography>
												)}
												<Typography
													scale="large"
													weight="600"
													textColor="green_300"
													className="text_center"
												>
													{priceFormatFinancial(price.loanAmount, 0)}
												</Typography>
											</div>
										</div>
									</div>
								))}
							</div>

							<div className="bg_neutral_400 br_sm  m_b_xxl">
								<div className="bg_neutral_0 br_t_sm display_flex p_y_sm p_x_lg flex_align_center flex_justify_between">
									<Typography
										scale="large"
										weight="600"
										textColor="neutral_900"
									>
										Alertas del Vehículo
									</Typography>
								</div>
								<div className="p_lg p_r_sm display_flex flex_gap_sm flex_col ">
									<div className="alarms_section p_r_sm">
										{alarms.map((alarm: any) => (
											<div
												className="p_x_lg p_y_sm br_md m_b_xs bg_neutral_0 display_flex flex_gap_lg"
												key={alarm._id}
											>
												{!alarm.read && (
													<div className="dim_sm br_circle bg_red_300" />
												)}
												<div className="flex_grow_1">
													<div className="display_flex flex_align_center m_b_md flex_justify_between ">
														<Typography
															scale="small"
															weight="600"
															textColor="neutral_900"
														>
															{alarm.title}
														</Typography>
														<Typography
															scale="xsmall"
															weight="600"
															textColor="neutral_600"
														>
															{momentLocal(alarm.createdAt).format(
																'DD/MM/YYYY HH:mm',
															)}
														</Typography>
													</div>
													<Typography
														scale="xsmall"
														weight="400"
														textColor="neutral_600"
													>
														{alarm.description}
													</Typography>
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<div>Cargando...</div>
			)}
			<EditVehicle
				open={openDetails}
				setOpen={setOpenDetails}
				values={vehicle}
				setResult={(vehi: VehiclePopulated) => {
					setVehicle(vehi);
					if (vehi.images.length > 0) {
						setPhotos(vehi.images);
					}
				}}
			/>
			<EdiVehiclePricing
				open={openEditPricing}
				setOpen={setOpenEditPricing}
				values={vehicle}
				setResult={(vehi: VehiclePopulated) => {
					setVehicle(vehi);
				}}
			/>
			{openHistory && vehicle?._id && (
				<History
					entityId={[vehicle._id]}
					open={openHistory}
					setOpen={setOpenHistory}
				/>
			)}
			{loanTimes && loanTimes.length ? (
				<AddEditDiscount
					open={openAddEditDiscount}
					vehicle={vehicle}
					setOpen={setOpenAddEditDiscount}
					setResult={setVehicle}
					initials={activeDiscount}
					loanTimes={loanTimes}
				/>
			) : null}
			{openDevices ? (
				<SelectDeviceModal
					open={openDevices}
					setOpen={setOpenDevices}
					type
					assignDevice={(newDevice: any) => {
						setSelectedDevice(newDevice);
						setOpenDeviceConfirm(true);
					}}
				/>
			) : null}
			{openAddVehicleFile && vehicle ? (
				<AddVehicleFile
					open={openAddVehicleFile}
					setOpen={setOpenAddVehicleFile}
					vehicle={vehicle}
					setResult={setVehicle}
				/>
			) : null}
			<ModalConfirmation
				openConfirmation={openDeviceConfirm}
				handleClose={() => {
					setOpenDeviceConfirm(false);
				}}
				icon={<Position />}
				isConfirmationLoading={false}
				widthDesktop={40}
				actions={[
					{
						label: 'Cancelar',
						color: 'grey',
						action: () => {
							setOpenDeviceConfirm(false);
							setSelectedDevice(undefined);
						},
					},
					{
						label: 'Cambiar Dispositivo',
						color: 'primary',
						action: () => {
							assignDevice();
						},
						loading: loadingSetDevice,
					},
				]}
				title={
					<Typography scale="large" weight="400">
						¿Estás seguro de que{' '}
						<Typography scale="large" weight="600" component="span">
							deseas cambiar el dispositivo GPS?
						</Typography>
					</Typography>
				}
				subtitle={
					<Typography scale="medium" weight="400" textColor="neutral_700">
						Se cambiara del dispositivo con IMEI {device?.imei} al dispositivo
						con IMEI {selectedDevice?.imei}
					</Typography>
				}
			/>
			<ModalConfirmation
				openConfirmation={openDeviceRemove}
				handleClose={() => {
					setOpenDeviceRemove(false);
				}}
				icon={<Position />}
				isConfirmationLoading={false}
				widthDesktop={40}
				actions={[
					{
						label: 'Cancelar',
						color: 'grey',
						action: () => {
							setOpenDeviceRemove(false);
						},
					},
					{
						label: 'Desasignar Dispositivo',
						color: 'primary',
						action: () => {
							removeDevice();
						},
						loading: loadingSetDevice,
					},
				]}
				title={
					<Typography scale="large" weight="400">
						¿Estás seguro de que{' '}
						<Typography scale="large" weight="600" component="span">
							deseas Eliminar la asignacion de este dispositivo?
						</Typography>
					</Typography>
				}
				subtitle={
					<Typography scale="medium" weight="400" textColor="neutral_700">
						Se eliminara del vehiculo el dispositivo con IMEI {device?.imei}
					</Typography>
				}
			/>
			{openTiles ? (
				<SelectDeviceModal
					open={openTiles}
					setOpen={setOpenTiles}
					type={false}
					assignDevice={(newTile: any) => {
						setSelectedTile(newTile);
						setOpenTileConfirm(true);
					}}
				/>
			) : null}
			<ModalConfirmation
				openConfirmation={openTileConfirm}
				handleClose={() => {
					setOpenTileConfirm(false);
				}}
				icon={<Position />}
				isConfirmationLoading={false}
				widthDesktop={40}
				actions={[
					{
						label: 'Cancelar',
						color: 'grey',
						action: () => {
							setOpenTileConfirm(false);
							setSelectedTile(undefined);
						},
					},
					{
						label: 'Cambiar Dispositivo',
						color: 'primary',
						action: () => {
							assignTile();
						},
						loading: loadingSetTile,
					},
				]}
				title={
					<Typography scale="large" weight="400">
						¿Estás seguro de que{' '}
						<Typography scale="large" weight="600" component="span">
							deseas cambiar el dispositivo Tile?
						</Typography>
					</Typography>
				}
				subtitle={
					<Typography scale="medium" weight="400" textColor="neutral_700">
						Se cambiara del dispositivo con UUID {tile?.uuid} al dispositivo con
						UUID {selectedTile?.uuid}
					</Typography>
				}
			/>
			<ModalConfirmation
				openConfirmation={openTileRemove}
				handleClose={() => {
					setOpenTileRemove(false);
				}}
				icon={<Position />}
				isConfirmationLoading={false}
				widthDesktop={40}
				actions={[
					{
						label: 'Cancelar',
						color: 'grey',
						action: () => {
							setOpenTileRemove(false);
						},
					},
					{
						label: 'Desasignar Dispositivo',
						color: 'primary',
						action: () => {
							removeTile();
						},
						loading: loadingSetTile,
					},
				]}
				title={
					<Typography scale="large" weight="400">
						¿Estás seguro de que{' '}
						<Typography scale="large" weight="600" component="span">
							deseas Eliminar la asignacion de este dispositivo?
						</Typography>
					</Typography>
				}
				subtitle={
					<Typography scale="medium" weight="400" textColor="neutral_700">
						Se eliminara del vehiculo el dispositivo con UUID {tile?.uuid}
					</Typography>
				}
			/>
		</div>
	);
}

export default DetailsInventory;
